import { ProductNamesQueryDTO } from "@shared/DTO";

export const buildProductNamesKey = (filters: ProductNamesQueryDTO = {}): string => {
  const query = new URLSearchParams();
  for (const field of ["type", "brand", "visibility"] as const) {
    const values = filters[field];
    if (values !== undefined) query.set(field, [...values].sort().join(","));
  }
  const params = query.toString();
  return params ? `names?${params}` : "names";
};
